<template>
  <div>
    <el-select :value="value" value-key="key" :placeholder="$t('table.type')" :size="size" @input="change($event)" :clearable="true">
      <el-option label="----------" value="" />
      <el-option label="账户充值" value="USER" />
      <el-option label="返佣" value="MARGIN" />
      <el-option label="账户提现" value="WITHDRAWALS" />
      <el-option label="账单结算" value="BILL" />
    </el-select>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  props: ['value', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/UserOrderTypeSelect.vue